module.exports = {"autoCompleteOptions":{"defaultBounds":{"Lat1":43.7498448900683,"Lng1":44.3583945139786,"Lat2":-79.7754317391886,"Lng2":-79.1561358656633},"types":["geocode"],"componentRestrictions":{"country":"ca"}}}


//////////////////
// WEBPACK FOOTER
// ./public/data/gm-auto-complete.json
// module id = 8/x1
// module chunks = 1 2